import moment from 'moment';
import 'moment/locale/ar'; // Import Arabic locale
import i18n from '../i18n';
import { FALLBACK_LANGUAGE } from '../constants/constants.js';

moment.locale(i18n.resolvedLanguage || i18n.language || FALLBACK_LANGUAGE); // Reset the current language as default to avoid Arabic locale

export const getDate = (dateString, lang='en') => {
  // const dateString = "2025-08-07T11:40:06.784660+03:00";
  // const formatted = moment(dateString).format('YYYY-MM-DD HH:mm:ss'); // "2025-08-07 11:40:06"
  // const formatted = moment(dateString).format('YYYY-MM-DD'); // "2025-08-07"
  moment.locale(lang);
  if (lang === 'ar') {
    return moment(dateString).format('D MMM YYYY');  // Output: "٧ أغسطس ٢٠٢٥"
  } else {
    return moment(dateString).format('MMM D, YYYY');  // Output: "Aug 7, 2025"
  }
};

export const getDateTime = (dateString, lang = 'en') => {
  moment.locale(lang);
  
  if (lang === 'ar') {
    return moment(dateString).format('D MMM YYYY - HH:mm');  // Output: "٧ أغسطس ٢٠٢٥ - ١١:٤٠"
  } else {
    return moment(dateString).format('MMM D, YYYY [at] h:mm A');  // Output: "Aug 7, 2025 at 11:40 AM"
  }
};
